import { AxiosResponse } from "axios";
import apiClient from "../../../../shared/infrastructure/api/client";

export interface AnnouncementAcknowledgementsDTO {
    announcement_ids: string[];
}

export const AnnouncementsAPI = {
    listAcknowledged: (): Promise<AxiosResponse<AnnouncementAcknowledgementsDTO>> =>
        apiClient.get("/announcements/acknowledgements"),

    acknowledge: (announcementIds: string[]): Promise<AxiosResponse<void>> =>
        apiClient.post("/announcements/acknowledgements", { announcement_ids: announcementIds }),
};
